module.exports = {"321323001":"众兴街道","321323002":"城厢街道","321323003":"来安街道","321323101":"爱园镇","321323102":"王集镇","321323103":"裴圩镇","321323104":"新袁镇","321323105":"李口镇","321323106":"临河镇","321323107":"穿城镇","321323110":"卢集镇","321323111":"三庄镇","321323200":"庄圩乡","321323400":"棉花原种场","321323401":"泗阳农场","321323402":"江苏泗阳开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321323.json
// module id = 1038
// module chunks = 0